import { defineMessages } from '../../../i18n/define';

/** Подписи «Основы форм» (F0). Один набор на все поля: поле само ничего не пишет по-русски. */
export const FM = defineMessages({
  optional: {
    id: 'common.forms.field.optional',
    defaultMessage: '(необязательно)',
    description: 'Пометка у подписи необязательного поля формы, после названия: «Комментарий (необязательно)»',
  },
  explainFallback: {
    id: 'common.forms.field.explainFallback',
    defaultMessage: 'значение',
    description: 'Запасное имя поля для экранного диктора у знака «?», когда подпись не строка; строчная',
  },

  dateClear: {
    id: 'common.forms.date.clear',
    defaultMessage: 'Сбросить дату',
    description: 'aria-label крестика внутри поля даты: очистить значение',
  },
  dateFallback: {
    id: 'common.forms.date.fallbackLabel',
    defaultMessage: 'дата',
    description: 'Запасное имя поля даты для экранных дикторов, если подписи нет; строчная',
  },
  dateOpen: {
    id: 'common.forms.date.openCalendar',
    defaultMessage: 'Открыть календарь',
    description: 'aria-label кнопки с иконкой календаря в поле даты',
  },
  datePick: {
    id: 'common.forms.date.pickDate',
    defaultMessage: 'Выбор даты: {field}',
    description: 'aria-label окна календаря; {field} — название поля («Начало периода»)',
  },
  datePrev: {
    id: 'common.forms.date.previousMonth',
    defaultMessage: 'Предыдущий месяц',
    description: 'aria-label стрелки в окне календаря',
  },
  dateNext: {
    id: 'common.forms.date.nextMonth',
    defaultMessage: 'Следующий месяц',
    description: 'aria-label стрелки в окне календаря',
  },
  dateOutOfRange: {
    id: 'common.forms.date.outOfRange',
    defaultMessage: 'Дата должна быть с {min} по {max}',
    description: 'Ошибка поля даты: введённая дата вне допустимого окна; {min}/{max} — границы с годом',
  },
  dateNotBefore: {
    id: 'common.forms.date.notBefore',
    defaultMessage: 'Дата не раньше {min}',
    description: 'Ошибка поля даты: введённая дата раньше допустимой; {min} — граница с годом',
  },
  dateNotAfter: {
    id: 'common.forms.date.notAfter',
    defaultMessage: 'Дата не позже {max}',
    description: 'Ошибка поля даты: введённая дата позже допустимой; {max} — граница с годом',
  },
  dateUnavailable: {
    id: 'common.forms.date.unavailable',
    defaultMessage: 'Эта дата недоступна',
    description: 'Ошибка поля даты: введена дата, которую выбрать нельзя',
  },
  segDay: {
    id: 'common.forms.date.segment.day',
    defaultMessage: 'дд',
    description: 'Подсказка в пустом сегменте «день» поля даты; две буквы, как в «дд.мм.гггг»',
  },
  segMonth: {
    id: 'common.forms.date.segment.month',
    defaultMessage: 'мм',
    description: 'Подсказка в пустом сегменте «месяц» поля даты; две буквы',
  },
  segYear: {
    id: 'common.forms.date.segment.year',
    defaultMessage: 'гггг',
    description: 'Подсказка в пустом сегменте «год» поля даты; четыре буквы',
  },

  rangeFrom: {
    id: 'common.forms.range.from',
    defaultMessage: 'Начало',
    description: 'aria-label первой даты периода',
  },
  rangeTo: {
    id: 'common.forms.range.to',
    defaultMessage: 'Конец',
    description: 'aria-label второй даты периода',
  },
  rangeReversed: {
    id: 'common.forms.range.reversed',
    defaultMessage: 'Конец периода раньше начала',
    description: 'Ошибка поля периода: вторая дата раньше первой',
  },
  rangePresets: {
    id: 'common.forms.range.presets',
    defaultMessage: 'Быстрый выбор',
    description: 'aria-label ряда готовых периодов в окне календаря («Окно работы», «Последние 7 дней»)',
  },
  rangePlan: {
    id: 'common.forms.range.plan',
    defaultMessage: 'По плану: {from} — {to}',
    description: 'Подсказка под полем периода: срок по плану; {from}/{to} — даты',
  },
  rangeApplyPlan: {
    id: 'common.forms.range.applyPlan',
    defaultMessage: 'Подставить',
    description: 'Кнопка рядом с подсказкой «по плану»: подставить срок плана в поле',
  },

  seasonDay: {
    id: 'common.forms.season.day',
    defaultMessage: 'День',
    description: 'Подпись числа месяца в поле «день и месяц сезона»; коротко',
  },
  seasonMonth: {
    id: 'common.forms.season.month',
    defaultMessage: 'Месяц',
    description: 'Подпись месяца в поле «день и месяц сезона»; коротко',
  },
  seasonYear: {
    id: 'common.forms.season.year',
    defaultMessage: 'Год',
    description: 'Подпись выбора «предыдущего / того же года» в поле «день и месяц сезона»',
  },
  seasonFrom: {
    id: 'common.forms.season.from',
    defaultMessage: 'Начало окна',
    description: 'Подпись начала окна в поле «день и месяц сезона»',
  },
  seasonTo: {
    id: 'common.forms.season.to',
    defaultMessage: 'Конец окна',
    description: 'Подпись конца окна в поле «день и месяц сезона»',
  },
  seasonPrev: {
    id: 'common.forms.season.prevYear',
    defaultMessage: 'предыдущего года',
    description: 'Вариант года окна шаблона: дата относится к году ДО года урожая («5 сентября предыдущего года»)',
  },
  seasonSame: {
    id: 'common.forms.season.sameYear',
    defaultMessage: 'того же года',
    description: 'Вариант года окна шаблона: дата в году урожая',
  },
  seasonNext: {
    id: 'common.forms.season.nextYear',
    defaultMessage: 'следующего года',
    description: 'Вариант года окна шаблона: дата в году ПОСЛЕ года урожая',
  },
  seasonPlan: {
    id: 'common.forms.season.plan',
    defaultMessage: 'По плану: {from} — {to}',
    description: 'Подсказка под полем окна сезона: окно по плану; {from}/{to} — день, месяц и год («5 сен предыдущего года»)',
  },
  seasonWithYear: {
    id: 'common.forms.season.withYear',
    defaultMessage: '{date} {year}',
    description: 'День сезона с указанием года окна: «5 сентября предыдущего года»; {date} — «5 сентября», {year} — вариант года',
  },

  selectPlaceholder: {
    id: 'common.forms.select.placeholder',
    defaultMessage: 'Выберите',
    description: 'Подсказка в выпадающем списке, пока ничего не выбрано',
  },
  searchPlaceholder: {
    id: 'common.forms.select.searchPlaceholder',
    defaultMessage: 'Найти по названию',
    description: 'Подсказка в поле поиска выпадающего списка; коротко',
  },
  openList: {
    id: 'common.forms.select.openList',
    defaultMessage: 'Открыть список',
    description: 'aria-label кнопки-стрелки, раскрывающей список вариантов в поле поиска',
  },
  nothingFound: {
    id: 'common.forms.select.nothingFound',
    defaultMessage: 'Ничего не найдено. Измените запрос.',
    description: 'Пустой список вариантов, когда запрос ничего не нашёл',
  },
  loading: {
    id: 'common.forms.select.loading',
    defaultMessage: 'Загрузка…',
    description: 'Строка в списке вариантов, пока идёт поиск на сервере',
  },

  selectAll: {
    id: 'common.forms.checkboxGroup.selectAll',
    defaultMessage: 'Выбрать все · {count}',
    description: 'Строка над списком флажков: отметить все пункты; {count} — сколько пунктов',
  },
  selectFound: {
    id: 'common.forms.checkboxGroup.selectFound',
    defaultMessage: 'Выбрать найденные · {count}',
    description: 'Строка над списком флажков, когда включён поиск: отметить найденные пункты; {count} — сколько найдено',
  },
  selectedOf: {
    id: 'common.forms.checkboxGroup.selectedOf',
    defaultMessage: 'Выбрано {count} из {total}',
    description: 'Счётчик над списком флажков: отмечено {count} из {total} пунктов',
  },
  groupSearch: {
    id: 'common.forms.checkboxGroup.search',
    defaultMessage: 'Поиск по списку',
    description: 'aria-label поля поиска над списком флажков',
  },

  counter: {
    id: 'common.forms.textArea.counter',
    defaultMessage: '{count} / {max}',
    description: 'Счётчик знаков под многострочным полем: введено {count} из {max}',
  },
  increase: {
    id: 'common.forms.number.increase',
    defaultMessage: 'Увеличить',
    description: 'aria-label кнопки «плюс» в числовом поле',
  },
  decrease: {
    id: 'common.forms.number.decrease',
    defaultMessage: 'Уменьшить',
    description: 'aria-label кнопки «минус» в числовом поле',
  },

  dialogClose: {
    id: 'common.forms.dialog.close',
    defaultMessage: 'Закрыть',
    description: 'aria-label крестика в шапке окна с формой',
  },
  discardTitle: {
    id: 'common.forms.dialog.discardTitle',
    defaultMessage: 'Закрыть без сохранения?',
    description: 'Заголовок вопроса при закрытии окна с несохранённым вводом',
  },
  discardBody: {
    id: 'common.forms.dialog.discardBody',
    defaultMessage: 'Введённые данные не сохранятся.',
    description: 'Пояснение вопроса при закрытии окна с несохранённым вводом',
  },
  discardConfirm: {
    id: 'common.forms.dialog.discardConfirm',
    defaultMessage: 'Закрыть без сохранения',
    description: 'Кнопка подтверждения закрытия окна с несохранённым вводом',
  },
  discardKeep: {
    id: 'common.forms.dialog.discardKeep',
    defaultMessage: 'Продолжить ввод',
    description: 'Кнопка отказа от закрытия: вернуться к форме',
  },
  pending: {
    id: 'common.forms.actions.pending',
    defaultMessage: 'Выполняется…',
    description: 'aria-label основной кнопки формы, пока действие выполняется на сервере',
  },

  rowMenu: {
    id: 'common.forms.rowMenu.label',
    defaultMessage: 'Действия',
    description: 'aria-label кнопки «⋯» с меню действий строки',
  },
  toastUndo: {
    id: 'common.forms.toast.undo',
    defaultMessage: 'Отменить',
    description: 'Кнопка в уведомлении: отменить только что сделанное действие',
  },
  toastClose: {
    id: 'common.forms.toast.close',
    defaultMessage: 'Закрыть уведомление',
    description: 'aria-label крестика уведомления',
  },
  toastRegion: {
    id: 'common.forms.toast.region',
    defaultMessage: 'Уведомления',
    description: 'aria-label области уведомлений для экранного диктора',
  },
});
